import { TableComment } from "../../../general/src/TableComment";
import { RecOrderRates } from "../RecOrderRates";
import { RecurringScheduleTable } from "../RecurringScheduleTable";
import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringOrders extends Layout {
    buttonAddAnotherStop: Button;
    buttonCreateSchedule: Button;
    buttonOpenClassic: Button;
    buttonScheduler: Button;
    buttonUsers: Button;
    buttonViewRecurringOrder: Button;
    checkboxFloorLoadedFreight: Checkbox;
    checkboxHazmatRouting: Checkbox;
    checkboxHighValue: Checkbox;
    checkboxPreloaded: Checkbox;
    checkboxRoundTrip: Checkbox;
    checkboxTeamsRequired: Checkbox;
    dataheaderRecOrders: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    imageReorder: Image;
    labelAfterThisOrderIsSavedIWantTo: Label;
    labelCompanyPay: Label;
    labelContractDriverPayOptions: Label;
    labelCreditBadge: Label;
    labelTemperatureRange: Label;
    layoutRates: RecOrderRates;
    layoutRecurringSchedTable: RecurringScheduleTable;
    layoutTableComment: TableComment;
    panelCommodityCheckboxes: Panel;
    panelCompanyDriverPay: Panel;
    panelContractDriverPay: Panel;
    panelDataHeader2: Panel;
    panelDriverType: Panel;
    panelGeneral: Panel;
    panelNextActionButtons: Panel;
    panelNextActions: Panel;
    panelTempRange: Panel;
    sourceAgencyLink: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceRecurringOrder: DataSource;
    sourceRecurringSched: DataSource;
    sourceStopRecOrder: DataSource;
    stopsTable: Table;
    switchHazmat: Switch;
    switchIsActive: Switch;
    switchScheduled: Switch;
    tabComments: Tab;
    tabCommodity: Tab;
    tabDriverPay: Tab;
    tabEquipment: Tab;
    tabGeneral: Tab;
    tabNextActions: Tab;
    tabRate: Tab;
    tabScheduler: Tab;
    tabStops: Tab;
    tableEquipmentRequirements: Table;
    tabsetAddOrders: Tabset;
    textboxAgentPayeeId: Textbox;
    textboxBlnum: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrokerageWorkflowId: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxCompanyAmount: Textbox;
    textboxCompanyPayMethod: Textbox;
    textboxCompanyPercent: Textbox;
    textboxCustomerId: Textbox;
    textboxDefMoveType: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeIdEquipment: Textbox;
    textboxEquipmentTypeIdGeneral: Textbox;
    textboxHazmatCode: Textbox;
    textboxId: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderLength: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderOrderedBy: Textbox;
    textboxOrderType: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderedDate: Textbox;
    textboxOwnerAmount: Textbox;
    textboxOwnerPayMethod: Textbox;
    textboxOwnerPercent: Textbox;
    textboxPieces: Textbox;
    textboxRateSource: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
    textboxTractorType: Textbox;
    textboxWeight: Textbox;
}
